import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { ONLINE_PSI_REGS_STATUSES, STATUS_COLORS, ONLINE_PSI_REGS_STATUSES_ACTIONS, ONLINE_PSI_REGS_MAPPED_SEND_RECIVED_STATUSES } from 'shared/constants';
import './StudentStatus.scss';
import {
  ModalInfo, Dropdown, DropdownItem, AlertNotice, Textarea, Spinner, AlertMessage
} from 'shared/components';
import HourglassIcon from 'assets/svgs/hourglassIcon.svg';
import HourglassIconLarge from 'assets/svgs/hourglassIcon24.svg';
import { useDispatch } from 'react-redux';
import * as onlineTestingActions from '../duck';
import OnlineTestingService from '../OnlineTestingService';
import ArrowDownIcon from 'assets/svgs/arrowDownIcon.svg';
import { Radio } from 'shared/components';
import Parser from 'html-react-parser';



const StudentPsiStatus = ({
  cellData,
  scrollPosition,
  className,
  smallIcon,
  largeIcon,
  setLastFetchTime,
}) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);
  const [isTroubleshootModalOpen, setIsTroubleshootModalOpen] = useState(false);
  const [selected, setSelected] = useState('');
  const [isSpinnerVisible, setIsSpinnerVisible] = useState(false);
  const [isAlertMessageVisible, setIsAlertMessageVisible] = useState(false);
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');
  const [criticalError, setCriticalError] = useState('');
  const {roomId} = useParams();

  const hasLargeIcon = largeIcon ? <HourglassIconLarge /> : undefined;
  const hourglassIcon = smallIcon ? <HourglassIcon /> : hasLargeIcon;
  const isDropdownAvailable = cellData?.status !== undefined && cellData.status in ONLINE_PSI_REGS_STATUSES_ACTIONS;
  const dispatch = useDispatch();

  const toggleModal = () => {
    setError('');
    setIsModalOpen(!isModalOpen);
    setReason('');
  };

  const handleDropdownClick = async (status) => {
    const data = {regIDs: [cellData.regId]};

    if(status === 'troubleshoot') {
      dispatch(onlineTestingActions.getOnlineIndividualPsiReg(cellData.regId, true)).then((results)=> {
        if(cellData.status === 'error' && results.status !== 200){
          setCriticalError(t('onlineTesting.statusModal.criticalError'))
         }
      });
      setIsTroubleshootModalOpen(true);
      setSelected('');
      setError('');
      return;
    }
    if(status === 'mark_complete') {
      setIsModalOpen(true);
      return;
    }
    if(status === 'unassignregs') {
      setIsRemoveModalOpen(true);
      return;
    }
    await OnlineTestingService.putPsiStudentStatus(status, data);
    dispatch(onlineTestingActions.getOnlinePsiRegs(roomId));
    
    setLastFetchTime(moment().format('hh:mm:ss A'));
  };

  const onChange = (e) => {
    const { value } = e.target;
    setError('');
    setReason(value);
  };

  const handleContinue = async () => {
    if (!reason) {
      setError(t('errors.fieldRequired'));
      return;
    }
    const data = { regIDs: [cellData.regId],  markCompleteReason: reason };
    await OnlineTestingService.putPsiStudentStatus('markComplete', data);
    dispatch(onlineTestingActions.getOnlinePsiRegs(roomId));
    setLastFetchTime(moment().format('hh:mm:ss A'));
    setIsModalOpen(false);
  };

  const handleRemove = async () => {
    await OnlineTestingService.unassignExaminees(roomId, {absent: false, deniedReason: null, deniedReasonDetails: null, regIds: [cellData.regId]});
    dispatch(onlineTestingActions.getOnlinePsiRegs(roomId));
    setLastFetchTime(moment().format('hh:mm:ss A'));
    setIsRemoveModalOpen(false);
  };
  const handleTroubleshootSuccessClose = () => {
    setIsSpinnerVisible(false);
    setIsTroubleshootModalOpen(false);
    setIsAlertMessageVisible(true);
  }
  const handleCloseTroubleshoot = () => {
    setIsSpinnerVisible(false);
    setIsTroubleshootModalOpen(false);
    setError('');
  }

  const handleTroubleshootContinue = () => {
    setError('');
    if(selected){
        setIsSpinnerVisible(true);
        const actiondData = {regIDs: [cellData.regId]};
        const markCompleteData = { regIDs: [cellData.regId],  markCompleteReason: cellData.markedCompleteReason };
        const data = selected === 'markComplete' ? markCompleteData : actiondData;
        let resultStatus = null;
        OnlineTestingService.putPsiStudentStatus(selected, data)
        .then(() => {
          const statusRequestInterval = setInterval(() => {
            dispatch(onlineTestingActions.getOnlineIndividualPsiReg(cellData.regId, false)).then((results)=> {;
            if (results.status === ONLINE_PSI_REGS_MAPPED_SEND_RECIVED_STATUSES[selected] ) {
              clearInterval(statusRequestInterval);
              handleTroubleshootSuccessClose();
              resultStatus = results.status;
            }
          });
          }, 2000);

          setTimeout(() => {
            clearInterval(statusRequestInterval);
            if (resultStatus !== ONLINE_PSI_REGS_MAPPED_SEND_RECIVED_STATUSES[selected] ) {
              dispatch(onlineTestingActions.getOnlineIndividualPsiReg(cellData.regId, true)).then((results)=> {
                if (results.status === ONLINE_PSI_REGS_MAPPED_SEND_RECIVED_STATUSES[selected]){
                  handleTroubleshootSuccessClose();
                }
                if(typeof results.status !== 'number' && results.status !== ONLINE_PSI_REGS_MAPPED_SEND_RECIVED_STATUSES[selected]) {
                  setIsSpinnerVisible(false);
                  setError(t('onlineTesting.statusModal.requestErrorInfo'));
                }
                if(typeof results.status === 'number' && results.status !== 200){
                  setIsSpinnerVisible(false);
                  setCriticalError(t('onlineTesting.statusModal.criticalError'));
                }
              });
            }
          }
          , 20000);

        })
        .catch(() => {
          setIsSpinnerVisible(false);
          setError(t('onlineTesting.statusModal.requestErrorInfo'));
        }
      );
  } else {
    handleTroubleshootSuccessClose();
  }
};

const renderTroubleshootModalBody = () => {

  if(isSpinnerVisible){
    return <div className='status-state'>
            <AlertNotice message={t('onlineTesting.statusModal.requestInfo',  { status: selected === 'markComplete' ? 'mark complete' : selected })} type="info" />
            <Spinner customText={t('common.labels.processing')}/>
          </div>
  }
  if(error){
    return <div className='status-state'>
            <AlertNotice message={error} type="error" />
          </div>
    }

  if(criticalError){
    return <div className='status-state'>
            <AlertNotice message={criticalError} type="error" />
          </div>
    }

    return <div>
              <h5 className='troubleshoot-header'>{t('onlineTesting.statusModal.proceedQuestion')}</h5>
              <Radio
                value={''}
                label={Parser(t('onlineTesting.statusModal.correctStatus'))}
                checked={selected === ''}
                disabled={false}
                onChange={(e)=> setSelected(e.target.value)}
              />
              <Radio
                value={'start'}
                label={Parser(t('onlineTesting.statusModal.retryStart'))}
                checked={selected === 'start'}
                disabled={false}
                onChange={(e)=> setSelected(e.target.value)}
              />
              <Radio
                value={'pause'}
                label={Parser(t('onlineTesting.statusModal.retryPause'))}
                checked={selected === 'pause'}
                disabled={false}
                onChange={(e)=> setSelected(e.target.value)}
              />
              <Radio
                value={'unpause'}
                label={Parser(t('onlineTesting.statusModal.retryUnpause'))}
                checked={selected === 'unpause'}
                disabled={false}
                onChange={(e)=> setSelected(e.target.value)}
              />
              {cellData.markedCompleteReason && <Radio
                value={'markComplete'}
                label={Parser(t('onlineTesting.statusModal.retryMarkComplete'))}
                checked={selected === 'markComplete'}
                disabled={false}
                onChange={(e)=> setSelected(e.target.value)}
              />}
          </div>
}

  if(!cellData) {
    return null;
  }

  return (
    <>
      <Dropdown
        icon={hourglassIcon}
        title={ONLINE_PSI_REGS_STATUSES[cellData.status]}
        chevron={isDropdownAvailable ? <ArrowDownIcon /> : ''}
        customClass={`status-dropdown-component  ${isDropdownAvailable ? 'dropdown-available': ''} ${className} ${STATUS_COLORS[cellData?.status]}`}
        isDropdownAvailable={isDropdownAvailable}
        scrollPosition={scrollPosition}
      >
        <div className="status-dropdown">
          {ONLINE_PSI_REGS_STATUSES_ACTIONS[cellData.status] && ONLINE_PSI_REGS_STATUSES_ACTIONS[cellData.status].map((action, index) => (
            <DropdownItem
              key={`${action}-${index}`}
              handleClick={() => handleDropdownClick(action)}
              text={action === 'unassignregs' ? t('onlineTesting.removeStudent') : ONLINE_PSI_REGS_STATUSES[action]}
            />
          ))}
        </div>
      </Dropdown>
      <AlertMessage
          show={isAlertMessageVisible}
          removeMessage={() => setIsAlertMessageVisible(false)}
          time={3000}
          message={t('onlineTesting.troubleshootUpdateSuccessful')}
      />
      <ModalInfo
        className="modal-mark-complete"
        modalIsOpen={isModalOpen}
        closeModal={toggleModal}
        onSubmit={handleContinue}
        headerTitle={t('onlineTesting.individualStatus.reason')}
        saveLabel={t('onlineTesting.individualStatus.markComplete')}
        cancelLabel={t('common.labels.cancel')}
        showCancel
      >
        <div>
          <div className="student-name">{`${cellData.lastName}, ${cellData.firstName}`}</div>
          <AlertNotice message={t('onlineTesting.individualStatus.alert')} type="warning" />
          <Textarea
            label={t('onlineTesting.individualStatus.completeReason')}
            labelInfo={t('onlineTesting.individualStatus.markingReason')}
            name="completeReason"
            value={reason}
            onChange={onChange}
            maxLength={500}
            error={error}
          />
        </div>
      </ModalInfo>
      <ModalInfo
        modalIsOpen={isRemoveModalOpen}
        closeModal={() => setIsRemoveModalOpen(false)}
        onSubmit={handleRemove}
        saveLabel={t('onlineTesting.removeStudent')}
        cancelLabel={t('common.labels.cancel')}
        className='action-student-modal'
        headerTitle={t('onlineTesting.individualStatus.reason')}
        hasRemoveButton
        showCancel
      >
        <div>
          <div className="modal-question">{t('onlineTesting.removeStudentModal.question')}</div>
          <div className="modal-message">{t('onlineTesting.removeStudentModal.message')}</div>
        </div>
      </ModalInfo>
      <ModalInfo
        modalIsOpen={isTroubleshootModalOpen}
        closeModal={handleCloseTroubleshoot}
        onSubmit={handleTroubleshootContinue}
        saveLabel={error ? t('common.labels.retry') : t('common.labels.continue')}
        cancelLabel={t('common.labels.cancel')}
        headerTitle="onlineTesting.statusModal.troubleshoot"
        className="modal-troubleshoot"
        showCancel
        showBottomButton={isSpinnerVisible || criticalError}
        bottomButtonLabel={criticalError ? 'common.labels.cancel' : 'common.labels.close'}
      >
        <h4 className='troubleshoot-title'>{`${t('onlineTesting.statusModal.troubleshoot')} ${cellData.lastName}, ${cellData.firstName}`}</h4>
        {!criticalError && <>
          <p className='current-info-header'>{t('onlineTesting.statusModal.currentDetails')}</p>
          <div className='current-info'>
            <div>
              <div><b>{t('onlineTesting.statusModal.test')}</b></div>
              <div><b>{t('onlineTesting.statusModal.status')}</b></div>
            </div>
            <div>
              <div>{cellData.sectionFormName || '-'}</div>
              <div>{ONLINE_PSI_REGS_STATUSES[cellData.status]}</div>
            </div>
          </div>
        </>
        }
        {renderTroubleshootModalBody()}
      </ModalInfo>
    </>
  );
};
export default StudentPsiStatus;

StudentPsiStatus.propTypes = {
  className: PropTypes.string,
};

StudentPsiStatus.defaultProps = {
  className: '',
};
